export default "<trackify-monthly-status [isRegularUser]=\"true\"></trackify-monthly-status>"